"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementModalComponents = exports.AgreementStore = exports.AgreementModal = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ModalContainer_1 = require("@CommonFrontend/Modal/ModalContainer");
var DIProvider_1 = require("@CommonFrontend/DIProvider/DIProvider");
var inversify_1 = require("inversify");
var AngularSyncStore_1 = __importStar(require("@CommonFrontend/Utils/AngularSyncStore"));
var mobx_1 = require("mobx");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var styles = __importStar(require("./AgreementModal.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var AgreementBlockContainer_1 = require("./AgreementBlockContainer");
var agreementModalOffset = 1054;
exports.AgreementModal = (0, mobx_react_1.observer)(function (_a) {
    var onDismiss = _a.onDismiss;
    var agreementStore = (0, inversify_react_1.useInjection)(AgreementStore);
    var components = (0, inversify_react_1.useInjection)(exports.AgreementModalComponents.$);
    var agreementBlock = agreementStore.block;
    if (!agreementBlock) {
        return (react_1.default.createElement(ModalContainer_1.ModalContainer, { show: agreementStore.showModal, onDismiss: onDismiss },
            react_1.default.createElement("div", { className: styles.wrapper },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.container },
                    react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.header, direction: "horizontal", align: "center", justify: "end" },
                        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", paddingRight: "s", direction: "horizontal", align: "center" },
                            react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: onDismiss, icon: react_1.default.createElement(icons_1.Close, null) }))),
                    react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.spinner, align: "center", justify: "center" },
                        react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true }))))));
    }
    return (react_1.default.createElement(ModalContainer_1.ModalContainer, { show: agreementStore.showModal, onDismiss: onDismiss },
        react_1.default.createElement(kaleidoscope_1.Layer, { offset: agreementModalOffset }, function (_a) {
            var _b;
            var zIndex = _a.zIndex;
            return (react_1.default.createElement("div", { className: styles.wrapper, style: { zIndex: zIndex } },
                react_1.default.createElement("div", { className: styles.container },
                    react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.header, direction: "horizontal", align: "center", justify: "spaceBetween" },
                        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", paddingLeft: "s", direction: "horizontal", align: "center" },
                            agreementStore.showNavigation && (react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: function () {
                                    console.log("open menu");
                                }, icon: react_1.default.createElement(icons_1.Menu, null) })),
                            react_1.default.createElement(components.BlockTitle, { content: !!agreementStore.blockName ? agreementStore.blockName : "Untitled", onChange: function (value) {
                                    agreementStore.blockName = value;
                                } }),
                            react_1.default.createElement("div", { style: { border: "1px solid blue", padding: "8px" } },
                                react_1.default.createElement("p", null,
                                    "[DEBUG INFO] agreement: ", (_b = agreementStore === null || agreementStore === void 0 ? void 0 : agreementStore.block) === null || _b === void 0 ? void 0 :
                                    _b._id))),
                        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", paddingRight: "s", direction: "horizontal", align: "center" },
                            !!components.BlockSettings && (react_1.default.createElement(components.BlockSettings, { store: agreementStore, agreementBlock: agreementBlock })),
                            react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: onDismiss, icon: react_1.default.createElement(icons_1.Close, null), "aria-label": "Close agreement", tooltip: { content: "Close" } }))),
                    react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.body },
                        react_1.default.createElement(AgreementBlockContainer_1.AgreementBlockContainer, { block: agreementBlock },
                            react_1.default.createElement(components.BlockContent, null)),
                        react_1.default.createElement(components.AcceptForm, null)))));
        })));
});
var AgreementStore = (function (_super) {
    __extends(AgreementStore, _super);
    function AgreementStore(angularSyncServices, angularData) {
        var _this = _super.call(this, angularData, angularSyncServices, {
            extractDataFromAngular: function (initialData) {
                return { showAgreementModal: initialData.showAgreementModal, agreementBlock: initialData.agreementBlock };
            },
        }) || this;
        _this.onAngularUpdated = function (newData) {
            _this._showModal = newData.showAgreementModal;
            _this._agreementBlock = newData.agreementBlock;
        };
        _this.onAngularUpdated(angularData);
        return _this;
    }
    Object.defineProperty(AgreementStore.prototype, "dataForAngular", {
        get: function () {
            return { showAgreementModal: this._showModal, agreementBlock: this._agreementBlock };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "showModal", {
        get: function () {
            return this._showModal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "block", {
        get: function () {
            return this._agreementBlock;
        },
        set: function (newBlock) {
            this._agreementBlock = newBlock;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "showNavigation", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._agreementBlock) === null || _a === void 0 ? void 0 : _a.settings.showNavigation) !== null && _b !== void 0 ? _b : true;
        },
        set: function (value) {
            if (!this._agreementBlock) {
                throw new Error("Cannot update missing agreement block");
            }
            this._agreementBlock.settings.showNavigation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgreementStore.prototype, "blockName", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._agreementBlock) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
        },
        set: function (value) {
            if (!this._agreementBlock) {
                throw new Error("Cannot update missing agreement block");
            }
            this._agreementBlock.name = value;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Boolean)
    ], AgreementStore.prototype, "_showModal", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof BlockTypes_1.AgreementBlock !== "undefined" && BlockTypes_1.AgreementBlock) === "function" ? _a : Object)
    ], AgreementStore.prototype, "_agreementBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AgreementStore.prototype, "onAngularUpdated", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], AgreementStore.prototype, "showModal", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof BlockTypes_1.AgreementBlock !== "undefined" && BlockTypes_1.AgreementBlock) === "function" ? _b : Object),
        __metadata("design:paramtypes", [typeof (_c = typeof BlockTypes_1.AgreementBlock !== "undefined" && BlockTypes_1.AgreementBlock) === "function" ? _c : Object])
    ], AgreementStore.prototype, "block", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], AgreementStore.prototype, "showNavigation", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], AgreementStore.prototype, "blockName", null);
    AgreementStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)(AngularSyncStore_1.AngularSyncServices.$)),
        __param(1, (0, inversify_1.inject)("angularData")),
        __metadata("design:paramtypes", [typeof (_d = typeof AngularSyncStore_1.AngularSyncServices !== "undefined" && AngularSyncStore_1.AngularSyncServices) === "function" ? _d : Object, Object])
    ], AgreementStore);
    return AgreementStore;
}(AngularSyncStore_1.default));
exports.AgreementStore = AgreementStore;
exports.AgreementModalComponents = (0, DIProvider_1.makeServiceIdentifier)(Symbol("AgreementModalComponents"));
